import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { CircularProgress } from '@vk-hr-tek/ui/CircularProgress';
import { HTTP_BAD_REQUEST_STATUS } from '@vk-hr-tek/core/http';

import { PageError } from '../layout';

import { useAuthType } from './hooks';
import {
  GeneralAuth,
  VKAuth,
  AliAuth,
  CandidateAuth,
  OAuth2,
  OpenId,
  Esia,
} from './pages';

export const Auth = () => {
  const { status, authType, error } = useAuthType();

  if (status === 'idle' || status === 'loading')
    return (
      <Box display="flex" justifyContent="center" p="32">
        <CircularProgress size={50} />
      </Box>
    );

  if (status === 'failed')
    return (
      <PageError
        status={error?.status || HTTP_BAD_REQUEST_STATUS}
        errorMessage={error?.message}
      />
    );

  switch (authType) {
    case 'candidate':
      return <CandidateAuth />;

    case 'vk':
    case 'internalVpnOff':
      return <VKAuth />;

    case 'pass':
      return <AliAuth />;

    case 'openid_jwt':
      return <OpenId />;

    case 'oauth2':
    case 'openid':
      return <OAuth2 />;

    case 'esia':
      return <Esia />;

    default:
      return <GeneralAuth />;
  }
};
